import { addStream } from '../../epicStore'
import { merge, fromEvent, Observable } from 'rxjs'
import { pluck, map, tap, mapTo } from 'rxjs/operators'
import { StateObservable } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { PlayInObject } from '../../../../lib/playIn/types'
import playInActions from '../../../actions/playIns'
import { afterAllTypes, pluckFrom } from '../../../../lib/observables'
import { setSyncPlayInState } from '../../../actions/docs/syncPlayIn/syncPlayInActions'
import { DocsType } from '../../../actions/docs/docsTypes'

export const events$ = (doc) => merge(
  fromEvent<{ data: PlayInObject, isLocal?: boolean }>(doc, 'updated')
    .pipe(
      pluck('data'),
      map(docValue => setSyncPlayInState(docValue))
    ),
  fromEvent(doc, 'removed')
    .pipe(
      map(() => playInActions.removeDoc())
    )
)

const addPlayInEvents$ = (actions$, state: StateObservable<State>) => actions$.pipe(
  afterAllTypes(DocsType.SET_PLAY_IN_DOCUMENT, actionTypes.SET_ROLE),
  pluckFrom(DocsType.SET_PLAY_IN_DOCUMENT),
  map((doc) => events$(doc)),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  mapTo(playInActions.listenersAdded())
)

export default addPlayInEvents$
